import React from 'react';
import { Product } from '../../../../../../models/interfaces/Product.interface';
import {
  CustomDataTableConfig,
  HeadCell,
} from '../../../../../../commons/components/custom-data-table/custom-data-table-config.model';
import { useNavigate } from 'react-router-dom';
import CustomDataTableComponent from '../../../../../../commons/components/custom-data-table/custom-data-table.component';
import routeService from '../../../../../../routes/route.service';

interface ProductTableComponentProps {
  userId: number;
  businessObjectId: number;
  categoryId: number;
  products?: Product[];
}

export default function ProductTableComponent(props: ProductTableComponentProps) {
  const navigate = useNavigate();

  const headCells: HeadCell[] = [
    { id: 'id', field: 'id', label: 'ID' },
    { id: 'displayOrder', field: 'displayOrder', label: 'Display order' },
    { id: 'name', field: 'name', label: 'Name' },
    { id: 'description', field: 'description', label: 'Description' },
    { id: 'price', field: 'price', label: 'Price' },
    { id: 'duration', field: 'duration', label: 'Duration' },
  ];

  const tableConfig: CustomDataTableConfig = {
    tableName: 'Products',
    rowsPerPage: 10,
    headCells,
  };

  const handleSelectRow = (selectedProduct: Product) => {
    if (selectedProduct?.id) {
      navigate(
        routeService.getAndFillProductDetailPath(
          props.userId,
          props.businessObjectId,
          props.categoryId,
          selectedProduct.id
        )
      );
    }
  };

  return (
    <CustomDataTableComponent tableConfig={tableConfig} data={props.products as Product[]} onSelect={handleSelectRow} />
  );
}
